import React from "react";
import "./App.css"; // Import the CSS file for styling

function CivilLaw(){

    return <div>

<img src="/civil.jpg" alt="Header" />

    </div>;

    


}




export default CivilLaw;